<template>
  <div class="tradmoney-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <DatePicker type="daterange"
                      format="yyyy-MM-dd"
                      split-panels
                      @on-change="changeDate"
                      style="width: 200px"
                      placeholder="开始时间 - 结束时间"></DatePicker>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入店铺名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.order_sn"
                 clearable
                 placeholder="订单编号..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Row>
      <Col :xs="24"
           :sm="24">
      <Alert>总收入：¥{{ total_prices }}</Alert>
      <div style="float: left;"
           v-model="total_prices"></div>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Modal v-model="showModalStatus"
           title="消费记录"
           :loading="loading">
      <Form action="javascript:void(0)">
        <Table border
               :columns="columns"
               ref="selection"
               :data="tablelist1"
               :loading="dataloading"></Table>
      </Form>
    </Modal>
    <Modal v-model="showTxModalStatus"
           title="修改提现"
           @on-ok="editTx('txInfoValidate')"
           :loading="loading">
      <Form :model="txInfo"
            action="javascript:void(0)"
            ref="txInfoValidate"
            :rules="txInfoValidate">
        <FormItem label="状态"
                  prop="status">
          <RadioGroup v-model="txInfo.tx_status">
            <Radio :label="0"
                   border>待体现</Radio>
            <Radio :label="1"
                   border>部分提现</Radio>
            <Radio :label="2"
                   border>已提现</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="提现金额"
                  prop="tx_price">
          <Input v-model="txInfo.tx_price"
                 placeholder="排序"></Input>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="biliStatus"
           title="比例设置"
           @on-ok="updateOrderBili()"
           :loading="loading">
      <Form :model="biliModel"
            :label-width="136">
        <FormItem label="一级分销商分销比例："
                  label-position="top">
          <Input v-model="biliModel.first_agent_fx"
                 placeholder="例如10"
                 style="width:200px"></Input>%
        </FormItem>
        <FormItem label="二级分销商分销比例："
                  label-position="top">
          <Input v-model="biliModel.agent_fx"
                 placeholder="例如10"
                 style="width:200px"></Input>%
        </FormItem>
        <FormItem label="B2C二级分销金额："
                  label-position="top">
          <Input v-model="biliModel.agent_fx_money"
                 placeholder="例如10"
                 style="width:200px"></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "tradmoney-list",
  data () {
    return {
      tradesman: {},
      loading: true,
      dataloading: true,
      title: "",
      datetime: [],
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: "",
        order_sn: ""
      },
      list: [
        {
          title: "订单编号",
          key: "order_num",
          width: 290
        },
        {
          title: "商家名称",
          key: "name",
          width: 150
        },
        {
          title: "收入来源",
          key: "income_sorce",
          width: 90
        },
        {
          title: "订单金额",
          key: "order_price",
          width: 100
        },
        {
          title: "实际收入",
          key: "prices",
          width: 100
        },
        {
          title: "订单状态",
          key: "order_status",
          width: 150
        },
        {
          title: "下单用户",
          key: "user",
          width: 150
        },
        {
          title: "下单时间",
          key: "order_time",
          width: 150
        },
        {
          title: "到账时间",
          key: "created_at",
          width: 150
        },
        {
          title: "提现状态",
          width: 90,
          key: "tx_status",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.tx_status == 1
                  ? "部分呢提现"
                  : params.row.tx_status == 2
                    ? "已提现"
                    : "待提现"
              )
            ]);
          }
        },
        {
          title: "提现金额",
          key: "tx_price",
          width: 150
        },
        {
          title: "操作",
          key: "action",
          width: 350,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.txDetail(params.row.id);
                    }
                  }
                },
                "提现状态"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "详情"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display:
                      params.row.tx_status == "0" ? "inline-block" : "none"
                  },
                  on: {
                    click: () => {
                      this.showbili(params.row.order_num, params.row.is_park);
                    }
                  }
                },
                "修改分销比例"
              )
            ]);
          }
        }
      ],
      columns: [
        {
          title: "平台",
          key: "plat",
          width: 290
        },
        {
          title: "城市合伙人",
          key: "partner",
          width: 150
        },
        {
          title: "一级分销商",
          key: "first_agent",
          width: 90
        },
        {
          title: "二级分销商",
          key: "agent",
          width: 90
        },
        {
          title: "园区",
          key: "park",
          width: 90
        },
        {
          title: "园区服务费",
          key: "park_service",
          width: 90
        }
      ],
      reviewOrder: {},
      tablelist: [],
      tablelist1: [],
      total_prices: "0.00",
      showModalStatus: false,
      showTxModalStatus: false,
      biliStatus: false,
      biliModel: {},
      is_park: 0,
      txInfo: {
        tx_status: 0,
        tx_price: 0
      },
      txInfoValidate: [],
      is_park: 0
    };
  },
  created: function () {
    this.is_park = this.$route.params.is_park;
    this.getTableList();
  },
  methods: {
    getTableList: function () {
      this.$api.tradmoney
        .list({
          page: this.pages.page,
          size: this.pages.size,
          is_park: this.is_park
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.total_prices = res.result.total_price;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    changeDate (val) {
      this.datetime = val;
    },
    //提现
    txDetail (id) {
      // this.txInfo={
      //     tx_status:index.tx_status,
      //     tx_price:index.tx_price,
      // };
      this.$api.tradmoney.detail({ log_id: id }).then(res => {
        if (res.code == 200) {
          // this.showModalStatus = !this.showModalStatus;
          this.txInfo = res.result[0];
        }
      });
      this.showTxModalStatus = !this.showTxModalStatus;
    },
    editTx (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.tradmoney
            .txstatus({
              id: this.txInfo.id,
              tx_status: this.txInfo.tx_status,
              tx_price: this.txInfo.tx_price
            })
            .then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showTxModalStatus = !this.showTxModalStatus;
            });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 详情
    detail (index) {
      this.$api.tradmoney.detail({ log_id: index }).then(res => {
        if (res.code == 200) {
          this.showModalStatus = !this.showModalStatus;
          this.tablelist1 = res.result;
        }
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      var starttime = this.datetime[0] != undefined ? this.datetime[0] : "";
      var endtime = this.datetime[1] != undefined ? this.datetime[1] : "";
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        status: this.formItem.status,
        starttime: starttime,
        endtime: endtime,
        order_sn: this.formItem.order_sn,
        is_park: this.is_park
      };
      this.$api.tradmoney.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.total_prices = res.result.total_price;
        }
      });
      return;
    },
    //修改订单比例
    showbili (order_num, is_park) {
      this.biliStatus = true;
      this.order_num = order_num;
      this.biliModel.first_agent_fx = "";
      this.biliModel.agent_fx = "";
      this.biliModel.agent_fx_money = "";
      this.is_park = is_park;
      this.$api.tradmoney
        .getorderbili({
          order_num: this.order_num
        })
        .then(res => {
          if (res.code == 200) {
            this.biliModel = res.result;
          } else {
            this.$Message.success(res.msg);
          }
        });
    },
    updateOrderBili () {
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.tradmoney
            .updorderbili({
              order_num: this.order_num,
              first_agent_fx: this.biliModel.first_agent_fx,
              agent_fx: this.biliModel.agent_fx,
              agent_fx_money: this.biliModel.agent_fx_money,
              is_park: this.is_park
            })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.renderTable(1);
                this.biliStatus = false;
              } else {
                this.$Message.success(res.msg);
              }
            });
        }
      });
    }
  }
};
</script>